$(document).ready(function(){
  two_column_with_menu();
});

function two_column_with_menu() {
  $('.parent-link').on('click', function(event) {
    var target = $(event.target);

    if (target.closest('.menu__submenu-toggle, a').length) {
        var button = $(this).find('.menu__submenu-toggle');
        var ariaLabel = button.attr('aria-label');

        if (!button.hasClass('active')) {
            button.addClass('active')
                .attr('aria-label', ariaLabel.replace('Open', 'Close'))
                .parents('.menu-item').attr('aria-expanded', true).addClass('active')
                .find('.submenu').slideDown();
        } else {
            button.removeClass('active')
                .attr('aria-label', ariaLabel.replace('Close', 'Open'))
                .parents('.menu-item').attr('aria-expanded', false).removeClass('active')
                .find('.submenu').slideUp();
        }
    }
  });
}